import React from "react";
import { Link } from "react-router-dom";
import {
  homePageV2Welcome,
  homePageV2Happening,
  homePageV2Membership,
} from "../content/homePageV2Content";

export function WelcomeSectionV2() {
  const welcome = homePageV2Welcome;

  return (
    <section
      id="mh2v2-welcome"
      className="mh2v2-welcome mh2v2-section-light"
      aria-labelledby="mh2v2-welcome-heading"
    >
      <div className="mh2v2-container">
        <p className="mh2v2-eyebrow">{welcome.eyebrow}</p>
        <h2 id="mh2v2-welcome-heading" className="mh2v2-script">
          {welcome.headline}
        </h2>
        <p className="mh2v2-copy mh2v2-copy--center">{welcome.body}</p>

        <div className="mh2v2-region-row">
          {welcome.regions.map((region) => (
            <Link
              key={region.label}
              to={region.to}
              className={`mh2v2-pill mh2v2-pill--region ${region.color}`}
            >
              {region.label} →
            </Link>
          ))}
        </div>

        <div className="mh2v2-happening-grid">
          <div className="mh2v2-happening-left">
            <h3 className="mh2v2-section-title">SEE WHAT&apos;S HAPPENING:</h3>
            <div className="mh2v2-happening-list">
              {homePageV2Happening.map((item) => (
                <Link
                  to={item.to}
                  className={`mh2v2-happening-card ${item.color}`}
                  key={item.title}
                >
                  <div className="mh2v2-happening-card__icon">{item.icon}</div>
                  <div className="mh2v2-happening-card__body">
                    <h4>{item.title}</h4>
                    <p>{item.text}</p>
                  </div>
                  <div className="mh2v2-happening-card__arrow">→</div>
                </Link>
              ))}
            </div>
          </div>

          <aside className="mh2v2-membership-box">
            <h3 className="mh2v2-section-title">EXPLORE MEMBERSHIP:</h3>

            {homePageV2Membership.tiers.map((tier, index) => (
              <React.Fragment key={tier.title}>
                {index > 0 ? <div className="mh2v2-membership-divider" /> : null}
                <div className="mh2v2-membership-tier">
                  <div
                    className={`mh2v2-round-logo${
                      tier.logoSmall ? " mh2v2-round-logo--small" : ""
                    }`}
                  >
                    {tier.logo}
                  </div>
                  <h4>{tier.title}</h4>
                  {tier.title === "For All Moms" ? (
                    <p>
                      Starting with our <strong>FREE</strong> membership, you can always
                      upgrade for more resources.
                    </p>
                  ) : (
                    <p>
                      Join <strong>800+</strong> women+ entrepreneurs building sustainable
                      businesses.
                    </p>
                  )}
                  <Link to={tier.cta.to} className="mh2v2-pill mh2v2-pill--gold">
                    {tier.cta.label} →
                  </Link>
                </div>
              </React.Fragment>
            ))}
          </aside>
        </div>
      </div>
    </section>
  );
}

export default WelcomeSectionV2;
